import { useContext } from 'react';
import { LocalizationContext, LONG_TO_SHORT_INPUT_MAPPING, } from '../LocalizationProvider';
import IntlMessageFormat from 'intl-messageformat';
import { parse, format as fnsFormat } from 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { enUS, es, ja } from 'date-fns/locale';
export const locales = {
    en: enUS,
    es,
    ja,
};
export const formatMessage = (messages, key, values, locale = 'en') => {
    let formattedMessage;
    if (messages?.[locale]?.[key]) {
        const msg = new IntlMessageFormat(messages[locale][key], locale);
        formattedMessage = msg.format(values);
    }
    else {
        console.warn(`Cannot find the message id ${key} in the message bundle for locale ${locale}`);
    }
    return formattedMessage || key;
};
export const useLocalizationContext = () => {
    const { messages: sharedComponentMessages, locale, dateFormat, timeFormat, dateTimeFormat, } = useContext(LocalizationContext);
    const dateFnsUtils = new DateFnsUtils({ locale: locales[locale || 'en'] });
    const getDatePlaceholder = (format = dateFormat || 'P') => {
        return (LONG_TO_SHORT_INPUT_MAPPING[format] ||
            (format.startsWith('P') ? dateFnsUtils.getFormatHelperText(format).replace('mm', 'MM') : format));
    };
    const getTimePlaceholder = (format = timeFormat || 'p') => {
        return format.startsWith('p') ? dateFnsUtils.getFormatHelperText(format) : format;
    };
    return {
        messages: sharedComponentMessages,
        locale: locale || 'en',
        formatMessage: (messages, key, values) => formatMessage(messages, key, values, locale),
        parseDate: (date, format = dateFormat || 'P') => {
            try {
                return parse(date, LONG_TO_SHORT_INPUT_MAPPING[format] || format, new Date(), {
                    locale: locales[locale || 'en'],
                });
            }
            catch (error) {
                console.warn(`Cannot parse date with format ${format}`, error);
            }
        },
        parseTime: (date, format = timeFormat || 'p') => {
            try {
                return parse(date, format, new Date(), { locale: locales[locale || 'en'] });
            }
            catch (error) {
                console.warn(`Cannot parse time with format ${format}`, error);
            }
        },
        formatDate: (date, format = dateFormat || 'P') => {
            try {
                return fnsFormat(date, format, {
                    locale: locales[locale || 'en'],
                });
            }
            catch (error) {
                console.warn(`Cannot format date with format ${format}`, error);
            }
        },
        formatTime: (date, format = timeFormat || 'p') => {
            try {
                return fnsFormat(date, format, {
                    locale: locales[locale || 'en'],
                });
            }
            catch (error) {
                console.warn(`Cannot format time with format ${format}`, error);
            }
        },
        formatDateTime: (date, format = dateTimeFormat || 'Pp') => {
            try {
                return fnsFormat(date, format, {
                    locale: locales[locale || 'en'],
                });
            }
            catch (error) {
                console.warn(`Cannot format datetime with format ${format}`, error);
            }
        },
        getDatePlaceholder,
        getTimePlaceholder,
    };
};
